<template>
  <div
    :class="['group bg-gray-700 border-2 rounded-lg shadow-lg w-64 relative overflow-visible', selected ? 'border-orange-400' : data.__validationError ? (isWarning ? 'border-yellow-500' : 'border-red-500') : 'border-gray-600']"
  >
    <!-- Header del nodo -->
    <div class="bg-gray-800 p-3 rounded-t-lg flex items-center gap-2 justify-between">
      <div class="flex items-center gap-2">
        <span class="material-icons text-orange-400">http</span>
        <strong class="text-white">{{ $t('flowEditor.nodes.apiCallNode.title') }}</strong>
      </div>
      <ExitNodeBadge :active="data.__isExitNode" />
      <ValidationMarker :error="data.__validationError" />
    </div>
    
    <!-- Corpo del nodo -->
    <div class="p-3">
      <p class="text-gray-300 text-sm truncate">
        <span v-if="data.url">{{ data.method }} {{ data.url }}</span>
        <span v-else class="italic">{{ $t('flowEditor.nodes.apiCallNode.emptyPlaceholder') }}</span>
      </p>
    </div>

    <!-- Punti di connessione (Handles) -->
    <Handle type="target" :position="Position.Left" />
    <!-- Ramo di successo: resta l'handle SENZA id, cosi' gli edge gia' salvati
         (sourceHandle null) continuano a partire da qui. Vue Flow risolve un
         sourceHandle nullo con il PRIMO handle source del nodo (getEdgeHandle:
         `!handleId ? bounds[0] : ...`), quindi l'ordine qui sotto e' vincolante:
         spostare "error" prima farebbe saltare tutti i collegamenti esistenti
         sul ramo di errore, senza nessun errore visibile. -->
    <Handle type="source" :position="Position.Right" :style="{ top: '35%' }">
      <div class="absolute left-full ml-3 top-1/2 -translate-y-1/2 whitespace-nowrap text-xs bg-green-900 text-green-300 px-2 py-1 rounded-sm pointer-events-none">{{ $t('flowEditor.nodes.apiCallNode.successLabel') }}</div>
    </Handle>
    <!-- Ramo errore: se non e' collegato, il nodo interrompe il flusso come prima. -->
    <Handle id="error" type="source" :position="Position.Right" :style="{ top: '65%' }">
      <div class="absolute left-full ml-3 top-1/2 -translate-y-1/2 whitespace-nowrap text-xs bg-red-900 text-red-300 px-2 py-1 rounded-sm pointer-events-none">{{ $t('flowEditor.nodes.apiCallNode.errorLabel') }}</div>
    </Handle>
    <!-- Add node button -->
    <AddNodeButton v-if="!hasOutgoingEdge" placement="success" @add="emit('add-node', nodeId)" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Handle, Position } from '@vue-flow/core';
import ExitNodeBadge from './ExitNodeBadge.vue';
import AddNodeButton from './AddNodeButton.vue';
import ValidationMarker from './ValidationMarker.vue';

const emit = defineEmits(['add-node']);

const props = defineProps({
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
  nodeId: { type: String, required: true },
  hasOutgoingEdge: { type: Boolean, default: false },
});

const isWarning = computed(() => props.data.__validationError?.severity === 'warning');
</script>
